import { Grid } from "@mui/material";
import { objeto } from "shared/utils/states";
import { CurriculoContainer } from "../../components/CurriculoContainer";
import { useLocation } from "react-router-dom";
import { useGetInscricaoByIdQuery } from "shared/features/api/inscricao/inscricaoSlice";

export const ResultCurriculum = () => {
  const { state } = useLocation()
  const {data: inscricao} = useGetInscricaoByIdQuery(state.id);
  return (
    <Grid container spacing={2}>
      <Grid
        item
        xs={12}
        md={12}
        sx={{ height: "calc(100vh - 150px)", width: "100%" }}
      >
        {inscricao && (
          <CurriculoContainer inscricao={inscricao} />
        )}
      </Grid>
      {/* <Grid
        item
        xs={12}
        lg={6}
        sx={{ height: "calc(100vh - 150px)", width: "100%" }}
      ></Grid> */}
    </Grid>
  );
};
